export const convertWeightToText = (weight: number) => {
  switch (weight) {
    case 0:
      return 'Unimportant';
    case 0.5:
      return 'Less important';
    case 1:
      return 'Neutral';
    case 1.5:
      return 'Important';
    case 2:
      return 'Very important';
  }
};
